"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("@ux/button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sharedComponents = require("@site/shared-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getDisplayName = name => {
  if (name.length > 25) {
    return `...${name.slice(-25)}`;
  }
  return name;
};
const CustomSuggestionsFlyoutItems = ({
  iconsAndDomainsArray,
  maxDropDownSuggestions = 5,
  onClick,
  logger,
  showContentForDropdownBox
}) => {
  const domainFlyoutItems = (0, _react.useMemo)(() => {
    const items = [];
    iconsAndDomainsArray.forEach(iconAndDomainsObj => {
      iconAndDomainsObj.domainNames.forEach(domain => {
        items.push({
          icon: iconAndDomainsObj.icon,
          domain
        });
      });
    });
    return items.length <= maxDropDownSuggestions ? items : items.slice(0, maxDropDownSuggestions);
  }, [iconsAndDomainsArray, maxDropDownSuggestions]);
  return domainFlyoutItems.length ? domainFlyoutItems.map(({
    domain,
    icon
  }, index) => /*#__PURE__*/_react.default.createElement(_sharedComponents.ErrorBoundary, {
    fallback: null,
    key: domain,
    logErrorFunc: logger?.()
  }, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: "custom-domain-suggestions text-gray border-0",
    "data-testid": `iconAnd${domain}`,
    text: showContentForDropdownBox ? getDisplayName(domain) : domain
  }, icon && {
    icon
  }, {
    tabIndex: "0",
    value: domain,
    key: domain,
    onClick: () => onClick(domain, index + 1),
    "aria-label": `${domain}`
  })))) : null;
};
CustomSuggestionsFlyoutItems.propTypes = {
  onClick: _propTypes.default.func,
  iconsAndDomainsArray: _propTypes.default.arrayOf({
    icon: _propTypes.default.func,
    domainNames: _propTypes.default.arrayOf(_propTypes.default.string)
  }),
  maxDropDownSuggestions: _propTypes.default.number,
  logger: _propTypes.default.func,
  showContentForDropdownBox: _propTypes.default.bool
};
var _default = exports.default = CustomSuggestionsFlyoutItems;